import React from 'react';
import PropTypes from 'prop-types';
import { LoadingSpinner } from 'components/common';
import ContractMonthlyTrend from 'components/app/crm/dashboard/contracts/ContractMonthlyTrend';
import ContractDomesticOverseaChart from 'components/app/crm/dashboard/contracts/ContractDomesticOverseaChart';
import ContractTopRevenueChart from 'components/app/crm/dashboard/contracts/ContractTopRevenueChart';
import SummaryCard from '../components/SummaryCard';
import { BarList } from '../components/MiniCharts';
import OverviewDetailGrid from '../OverviewDetailGrid';

const money = (v) => {
  const n = Number(v || 0);
  if (n >= 1_000_000) return `$${(n / 1_000_000).toFixed(2)}M`;
  if (n >= 1_000) return `$${(n / 1_000).toFixed(0)}K`;
  return `$${n.toFixed(0)}`;
};

// Contract tab — full contract analytics: monthly trend, Domestic vs Oversea,
// Top by project + Top customers (who signed contracts), region / country
// value breakdowns, then the contract detail grid.
const ContractTab = ({ data, loading, baseParams, groupBy, onGroupByChange }) => {
  const region  = (data?.region  || []).map((r) => ({ label: r.region,  value: r.contract_value, sub: `${r.contract_count || 0} contracts` }));
  const country = (data?.country || []).map((c) => ({ label: c.country, value: c.contract_value, sub: `${c.contract_count || 0} contracts` }));

  if (loading && !data) return <div className="tw-text-center tw-py-12"><LoadingSpinner /></div>;

  return (
    <>
      <div className="tw-mb-3">
        <ContractMonthlyTrend data={data?.trend} loading={loading} groupBy={groupBy} onGroupByChange={onGroupByChange} />
      </div>

      <div className="tw-mb-3">
        <ContractDomesticOverseaChart data={data?.domestic_oversea} loading={loading} />
      </div>

      {/* Top projects + Top customers who signed contracts (by value) */}
      <div className="tw-mb-3">
        <ContractTopRevenueChart data={data?.top} loading={loading} />
      </div>

      <div className="tw-grid tw-grid-cols-12 tw-gap-3 tw-mb-3">
        <div className="tw-col-span-12 lg:tw-col-span-6">
          <SummaryCard title="By Sales Region" subtitle="Contract value per region">
            <div className="tw-col-span-12"><BarList items={region} color="#10b981" valueFmt={money} emptyText="No contracts." /></div>
          </SummaryCard>
        </div>
        <div className="tw-col-span-12 lg:tw-col-span-6">
          <SummaryCard title="By Country" subtitle="Contract value per country">
            <div className="tw-col-span-12"><BarList items={country} color="#0ea5e9" valueFmt={money} emptyText="No contracts." /></div>
          </SummaryCard>
        </div>
      </div>

      <OverviewDetailGrid section="contract" title="Contract Records" baseParams={baseParams} />
    </>
  );
};

ContractTab.propTypes = {
  data: PropTypes.object,
  loading: PropTypes.bool,
  baseParams: PropTypes.object.isRequired,
  groupBy: PropTypes.string,
  onGroupByChange: PropTypes.func
};
ContractTab.defaultProps = { data: null, loading: false, groupBy: 'month', onGroupByChange: () => {} };

export default ContractTab;
